import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from '@reduxjs/toolkit'
import logger from 'redux-logger'
import expireReducer from 'redux-persist-expire'
import persistReducer from 'redux-persist/es/persistReducer'
import storage from 'redux-persist/lib/storage'
import app from 'slices/app.slice'
import consultation from 'slices/consultation.slice'
import selectedPatient from 'slices/selectedPatient.slice'
import mentalHealth from 'slices/mentalHealth.slice'
import sessionDetail from 'slices/patientSessionDetail.slice'
import transcriptionReducer from 'slices/transcription.slice'
import { autoMergeLevel2 } from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import modalSlices from 'slices/modal.slice'
import callData from 'slices/manageCall.slice'
import timeZone from 'slices/timeZone.slice'

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  stateReconciler: autoMergeLevel2,
  whitelist: [
    'app',
    'consultation',
    'timeZone',
    'sessionDetail',
  ], // Persist only these slices
  transforms: [
    expireReducer(
      'consultation',
      {
        expireSeconds: 40000, // expire after almost 11+ hours
        expiredState: {},
        autoExpire: true,
      },
      consultation,
    ),
  ],
}
const reducer = combineReducers({
  app,
  consultation,
  selectedPatient,
  mentalHealth,
  sessionDetail,
  transcription: transcriptionReducer,
  modalSlices,
  callData,
  timeZone,
})

const persistedReducer = persistReducer(persistConfig, reducer)
const store = configureStore({
  reducer: persistedReducer,
  middleware:
    process.env.NODE_ENV === 'production'
      ? [...getDefaultMiddleware({ serializableCheck: false })]
      : [...getDefaultMiddleware({ serializableCheck: false }), logger],
})

export default store
